module.exports = __webpack_public_path__ + "static/img/banner.6ad1b7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/banner.png
// module id = Q7c0
// module chunks = 1